var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "change_buttons" },
    _vm._l(_vm.$AllProjects, function (project) {
      return [1, 3, 5].includes(project.id)
        ? _c(
            "div",
            { staticClass: "flex price_block" },
            [
              _c("span", { staticClass: "mr-1 project_title" }, [
                _c("strong", [_vm._v(_vm._s(project.title))]),
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.getPrices(_vm.drug.prices, project.id),
                function (price, index) {
                  return _c("div", [
                    index < 2
                      ? _c("span", { staticClass: "price_span" }, [
                          _vm._v(_vm._s(price.qty) + ": "),
                          _c("strong", [
                            _vm._v(_vm._s(+price.price * +_vm.drug.pack_set)),
                          ]),
                          _vm._v(
                            " (" +
                              _vm._s(
                                _vm.getProfitPercent(_vm.drug, price.price)
                              ) +
                              "%)"
                          ),
                        ])
                      : _c("span", { staticClass: "price_span" }, [
                          _vm._v(_vm._s(price.qty) + " ..."),
                        ]),
                  ])
                }
              ),
            ],
            2
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }